import React from 'react';

const SummaryView = ({ data }) => {
    if (!data) return null;

    const fields = [
        { key: "project_name", label: "Project Name" },
        { key: "general_contractor", label: "General Contractor" },
        { key: "owner", label: "Owner" },
        { key: "architect", label: "Architect" },
        { key: "project_address", label: "Project Address" },
        { key: "total_contract_value", label: "Total Contract Value" },
        { key: "project_start_date", label: "Start Date" },
        { key: "project_substantial_completion", label: "Substantial Completion" },
        { key: "pay_app_due_date", label: "Pay App Due Date" },
        { key: "retention_percent", label: "Retention %" },
        { key: "prevailing_wage", label: "Prevailing Wage" },
        { key: "joint_checks", label: "Joint Checks" },
        { key: "tax_status", label: "Tax Rate / Exempt" },
        { key: "parking", label: "Parking" },
        { key: "ocip_ccip_status", label: "OCIP / CCIP" },
        { key: "insurance_compliance", label: "Insurance Compliance" },
        { key: "material_deposits_required", label: "Material Deposits Required" }
    ];

    return (
        <div className="space-y-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Project Summary</h2>
            <div className="grid grid-cols-1 gap-4">
                {fields.map((field) => {
                    const value = data[field.key];
                    let valueClass = "text-gray-900";
                    let containerClass = "bg-white p-4 rounded border border-gray-200";

                    // Special styling for Insurance Compliance
                    if (field.key === "insurance_compliance") {
                        if (value?.includes("Not Compliant")) {
                            valueClass = "text-red-700 font-bold";
                            containerClass = "bg-red-50 p-4 rounded border border-red-200";
                        } else if (value?.includes("Compliant")) {
                            valueClass = "text-green-700 font-bold";
                            containerClass = "bg-green-50 p-4 rounded border border-green-200";
                        } else if (value?.includes("Cannot Be Confirmed")) {
                            valueClass = "text-yellow-700 font-bold";
                            containerClass = "bg-yellow-50 p-4 rounded border border-yellow-200";
                        }
                    }

                    // Special styling for Parking
                    if (field.key === "parking") {
                        if (value?.toLowerCase().includes("fee-based") || value?.toLowerCase().includes("subcontractor responsible")) {
                            valueClass = "text-yellow-700 font-semibold";
                            containerClass = "bg-yellow-50 p-4 rounded border border-yellow-200";
                        } else if (value?.toLowerCase().includes("included") || value?.toLowerCase().includes("provided") || value?.toLowerCase().includes("no cost")) {
                            valueClass = "text-green-700 font-semibold";
                            containerClass = "bg-green-50 p-4 rounded border border-green-200";
                        } else if (value?.toLowerCase().includes("not specified")) {
                            valueClass = "text-gray-500 italic";
                        }
                    }

                    // Special styling for Joint Checks
                    if (field.key === "joint_checks") {
                        if (value?.toLowerCase().startsWith("yes")) {
                            valueClass = "text-red-700 font-bold";
                            containerClass = "bg-red-50 p-4 rounded border border-red-200";
                        } else if (value?.toLowerCase().startsWith("no")) {
                            valueClass = "text-green-700 font-semibold";
                            containerClass = "bg-green-50 p-4 rounded border border-green-200";
                        }
                    }

                    // Special styling for Prevailing Wage
                    if (field.key === "prevailing_wage") {
                        if (value?.toLowerCase() === "yes") {
                            valueClass = "text-blue-700 font-semibold";
                            containerClass = "bg-blue-50 p-4 rounded border border-blue-200";
                        }
                    }

                    // Special styling for OCIP/CCIP
                    if (field.key === "ocip_ccip_status") {
                        if (value?.toLowerCase().includes("specified") || value?.toLowerCase().startsWith("yes")) {
                            valueClass = "text-blue-700 font-semibold";
                            containerClass = "bg-blue-50 p-4 rounded border border-blue-200";
                        }
                    }

                    return (
                        <div key={field.key} className={containerClass}>
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1 font-semibold">
                                {field.label}
                            </div>
                            <div className={`text-sm ${valueClass}`}>
                                {value || "Not identified"}
                            </div>
                            {/* Show Insurance details if not compliant */}
                            {field.key === "insurance_compliance" && data.insurance_notes && (
                                <div className="mt-2 text-xs text-gray-600 border-t border-gray-200 pt-2">
                                    {data.insurance_notes}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SummaryView;
